import { ROLES } from 'config/roles.config'
import GroboticFullDark from '../../images/Grobotic png.png'
import GroboticFullLight from '../../images/Grobotic png-lightmode.png'

export const createPlaceholderUser = theme => {
  return {
    firstName: 'Grobotic',
    lastName: 'Bot',
    role: 'Bot',
    id: ROLES.BOT,
    image_512: theme.palette.mode === 'dark' ? GroboticFullDark : GroboticFullLight,
  }
}
export const createPlaceholderNote = theme => {
  return [
    {
      owner: [ROLES.BOT],
      embedUrl: '',
      note_id: '24eff2d8-b46d-43f9-a10a-883035350d72',
      createdAt: '2199-01-01T01:38:21.105Z',
      attachments: [],
      iconLink: '',
      contents: `<p>This is a placeholder <span data-type="mention" data-id="${ROLES.BUSINESS_OWNER}" data-label="Justin Widmayer" data-image-url=""https://avatars.slack-edge.com/2024-06-24/7345528851616_ec58c3900477f70ad044_512.png">@Grobotic App</span> </p>`,
      tagIds: [`"${ROLES.BOT}"`],
      taggedUsers: [
        {
          name: 'Grobotic App',
          id: `"${ROLES.BOT}"`,
          imageUrl: theme.palette.mode === 'dark' ? GroboticFullDark : GroboticFullLight,
        },
      ],
      context: 'Placeholder',
      thumbnailLink: '',
    },
  ]
}
